import { Product } from '../../orders/models/Product';

export enum StockKind {
  MIN = 'min',
  MAX = 'max',
  THRESHOLD = 'threshold',
  REAL = 'real',
  PENDING_TO_RECEIVE = 'pending-receive',
  RESERVED = 'reserved',
}

export enum Warehouse {
  FACTORY = 1,
  INTERFRISA_GETAFE = 2,
  INTERFRISA_TERRASA = 3,
  FOODFORJOE_MASSANES = 4,
}

export enum StockChangeReason {
  NONE = '',
  INVENTORY = 'inventory',
  PRODUCT_ENTRY = 'product-entry',
  MISMATCH = 'mismatch',
  BROKEN_POOR_CONDITION_EXPIRED = 'broken-poor-condition-expired',
  SAMPLES = 'sample',
}

export interface StockLine {
  id?: number;
  kind: StockKind;
  quantity: number;
  warehouse: Warehouse;
  product: number;
  product_detail: Product;
  warehouse_detail: {
    id: number;
    name: string;
    address: number;
    cost_per_packing: number;
    cost_per_picking_line: number;
  };
  reason: StockChangeReason;
}
